import _extends from "@babel/runtime/helpers/esm/extends";

/* eslint-disable import/order */
// This file has been generated using @svgr/cli.
// Run "yarn generate:icons" in order to generate the files for new icons.
import * as React from 'react';
import styled from 'styled-components';
import { size, color } from 'styled-system';

var SvgComponent = function SvgComponent(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "24px",
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.722 35.096a1 1 0 0 1 1.3-.005c2.22 1.886 5.265 3.559 9.137 5.006a1 1 0 0 0 1.344-1.05c-.467-4.07-1.343-7.287-2.61-9.645a1 1 0 0 1 .318-1.3c2.314-1.58 4.772-4.005 7.364-7.277A1 1 0 0 0 40 19.226c-2.756-.588-5.972-.884-9.644-.884a1 1 0 0 1-.969-.753c-.889-3.495-2.293-6.552-4.21-9.179a1.002 1.002 0 0 0-1.615-.001c-1.913 2.607-3.313 5.664-4.2 9.178a1 1 0 0 1-.97.755c-3.62 0-6.82.295-9.599.883a1 1 0 0 0-.571 1.606c2.638 3.268 5.084 5.695 7.329 7.28a1 1 0 0 1 .298 1.3c-1.313 2.379-2.197 5.601-2.633 9.666a1 1 0 0 0 1.341 1.045c3.898-1.442 6.952-3.12 9.165-5.026Zm-8.471 6.902a3 3 0 0 1-4.024-3.135c.419-3.895 1.237-7.107 2.466-9.636-2.208-1.688-4.548-4.067-7.027-7.14a3 3 0 0 1 1.713-4.819c2.722-.575 5.802-.882 9.242-.921.956-3.447 2.398-6.49 4.329-9.121a3 3 0 0 1 4.841.005c1.933 2.646 3.378 5.687 4.335 9.115 3.489.04 6.585.347 9.291.924a3 3 0 0 1 1.726 4.797c-2.45 3.094-4.81 5.486-7.09 7.178 1.183 2.502 1.991 5.692 2.437 9.574a3 3 0 0 1-4.032 3.152c-3.718-1.39-6.745-2.996-9.08-4.824-2.335 1.85-5.378 3.464-9.127 4.85Z",
    fill: "currentColor"
  }));
};

var SvgStar = styled(SvgComponent).withConfig({
  displayName: "Star__SvgStar",
  componentId: "sc-13ls1yk-0"
})(["", " ", ""], size, color);
export default SvgStar;